<script>
	import { Col, Row } from "sveltestrap";

	export let caseDetails;
	export let damageLocations = "";
</script>

<div class="container p-0">
	<Row class="mb-3">
		<Col>
			<div class="description">Where is the damage?</div>
			<div class="value">{damageLocations}</div>
		</Col>
	</Row>
	<Row class="mb-3">
		<Col xs={4}>
			<div class="description">
				Final Amount<span style="color: red;">*</span>
			</div>
			<div class="value">{caseDetails.finalAmount}</div>
		</Col>
	</Row>
	<Row class="mb-3">
		<Col>
			<div class="description">
				Remarks<span style="color: red;">*</span>
			</div>
			<div class="value">{caseDetails.remarks}</div>
		</Col>
	</Row>
</div>
